export enum RiskTypeEnum {
  NORMAL = 'NORMAL',
  REVERSE_EVENT = 'REVERSE_EVENT'
}
